if (!customElements.get('mf-product-reviews')) {
  customElements.define('mf-product-reviews', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const list = this.querySelector('[data-review-list]');
      const cards = Array.from(list.querySelectorAll('[data-review-card]'));
      const filters = Array.from(this.querySelectorAll('[data-review-filter]'));
      const sort = this.querySelector('[data-review-sort]');
      const more = this.querySelector('[data-review-more]');
      const results = this.querySelector('[data-review-results]');
      const empty = this.querySelector('[data-review-empty]');
      const pageSize = Number(this.dataset.pageSize) || 4;
      let limit = pageSize, filter = 'all';
      const render = () => {
        let matched = cards.filter(card => filter !== 'photos' || card.dataset.hasPhoto === 'true');
        if (sort.value !== 'original') matched.sort((a,b) => sort.value === 'highest' ? Number(b.dataset.rating)-Number(a.dataset.rating) : Number(a.dataset.rating)-Number(b.dataset.rating));
        cards.forEach(card => { card.hidden = true; });
        matched.forEach((card,index) => { list.append(card); card.hidden = index >= limit; });
        more.hidden = matched.length <= limit;
        empty.hidden = matched.length > 0;
        results.textContent = this.dataset.resultsText.replace('[shown]',String(Math.min(limit,matched.length))).replace('[total]',String(matched.length));
      };
      filters.forEach(button => button.addEventListener('click', () => {
        filter = button.dataset.reviewFilter; limit = pageSize;
        filters.forEach(item => item.setAttribute('aria-pressed',String(item === button)));
        render();
      }, options));
      sort.addEventListener('change', () => { limit = pageSize; render(); }, options);
      more.addEventListener('click', () => {
        const previous = new Set(cards.filter(card => !card.hidden));
        limit += pageSize; render();
        const firstNew = Array.from(list.children).find(card => !card.hidden && !previous.has(card));
        if (firstNew) { firstNew.tabIndex = -1; firstNew.focus({ preventScroll: true }); }
      }, options);
      const lightbox = this.querySelector('[data-review-lightbox]');
      if (lightbox) {
        let source = null, savedOverflow = '';
        const close = () => lightbox.close();
        this.addEventListener('click', event => {
          const trigger = event.target.closest('[data-review-photo]');
          if (!trigger || !this.contains(trigger)) return;
          source = trigger;
          const image = lightbox.querySelector('[data-review-full-image]');
          image.src = trigger.dataset.photoSrc;
          image.alt = trigger.dataset.photoAlt || '';
          lightbox.querySelector('[data-review-photo-caption]').textContent = trigger.dataset.photoCaption || '';
          savedOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          lightbox.showModal();
          lightbox.querySelector('[data-review-photo-close]').focus();
        }, options);
        lightbox.querySelector('[data-review-photo-close]').addEventListener('click', close, options);
        lightbox.addEventListener('click', event => { if (event.target === lightbox || event.target.tagName === 'FIGURE') close(); }, options);
        lightbox.addEventListener('close', () => {
          document.documentElement.style.overflow = savedOverflow;
          source?.focus({ preventScroll: true });
        }, options);
        this.closePhoto = () => { if (lightbox.open) { lightbox.close(); document.documentElement.style.overflow = savedOverflow; } };
      }
      this.querySelector('[data-review-tools]').hidden = false;
      render();
    }
    disconnectedCallback() { this.closePhoto?.(); this.abort?.abort(); }
  });
}

